module.exports = __webpack_public_path__ + "img/90herringbone.eebe0e51.png";